import React from 'react';
import { useNavigate } from 'react-router';
import { useAppContext } from '../context/AppContext';
import ResultsTable from '../components/ResultsTable';
import HistoryTable from '../components/HistoryTable';

export default function ResultsPage() {
  const navigate = useNavigate();
  const ctx = useAppContext();
  if (!ctx) return null;

  const {
    toolResults, plan, mgBaseUrl, ibmBaseUrl, toAbs,
    history, error,
  } = ctx;

  const hasResults = !!toolResults;

  return (
    <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px 32px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 0',
          borderBottom: '1px solid #1e3a5f',
          marginBottom: 8,
        }}
      >
        <span style={{ color: '#94a3b8', fontSize: 14 }}>Discovery Results</span>
        <button className="btn btn-outline-success btn-sm" onClick={() => navigate('/search')}>
          + New Search
        </button>
      </div>

      {!hasResults && (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <p style={{ color: '#94a3b8', marginBottom: 20 }}>No results yet. Run a search to see results here.</p>
          <button className="btn btn-outline-success" onClick={() => navigate('/search')}>
            Start a Search
          </button>
        </div>
      )}

      {toolResults && (
        <div className="results-full-width">
          <ResultsTable
            toolResults={toolResults}
            plan={plan}
            mgBaseUrl={mgBaseUrl}
            ibmBaseUrl={ibmBaseUrl}
            toAbs={toAbs}
            onRefineMattergen={ctx.refineMattergen}
            onRefineFM4M={ctx.refineFM4M}
            onViewPlan={ctx.openPlan}
            onOpenFile={ctx.openFile}
          />
        </div>
      )}

      {/* Part 1a (1.11): Re-run is clicked in History below, so its error shows here too. */}
      {error && <div style={{ color: '#f87171' }}>{error}</div>}

      {history && history.length > 0 && (
        <>
          <div style={{ borderTop: '1px solid #1e3a5f', margin: '24px 0 20px' }} />
          <h5 style={{ color: '#94a3b8', marginBottom: 16, fontWeight: 500 }}>Run History</h5>
          <div className="results-full-width">
            <HistoryTable
              onViewResults={(h) => ctx.viewHistoryRun(h)}
            />
          </div>
        </>
      )}
    </div>
  );
}
